import { ActionTree } from 'vuex';
import { ESettingsActions, ESettingsMutations } from '@/settings/store/settings.constants';
import { ISettingsState } from '@/settings/store/settings.types';
import { RootState } from '@/store/store';

export const actions: ActionTree<ISettingsState, RootState> = {
  [ESettingsActions.Load]({ commit }) {
    commit(ESettingsMutations.SetLoading, true);
  },
};
